module.exports = __webpack_public_path__ + "static/media/left-arrow-orange.149abe27.svg";